import { ProductGridSkeletonTriggerProps } from '../../types/components/shared/ProductGridSkeletonTrigger';

import { useEffect } from 'react';
import { useRouter } from 'next/router';

const ProductGridSkeletonTrigger: React.FC<ProductGridSkeletonTriggerProps> = ({
  setDisplaySkeleton,
}) => {
  const router = useRouter();

  const checkIfRouteChangedForSearch = (url: string): boolean => {
    let route = url.split('?')[0];
    return route.includes('/products') || route.includes('/3d') || route.includes('/practice-footage') || route.includes('/category');
  }

  useEffect(() => {
    const handleRouteStart = (url: string) => {
      const shouldDisplaySkeleton = checkIfRouteChangedForSearch(url);
      setDisplaySkeleton(shouldDisplaySkeleton);
    };

    const handleRouteComplete = () => {
      setDisplaySkeleton(false);
    };

    const handleRouteError = () => {
      setDisplaySkeleton(false);
    };

    router.events.on('routeChangeStart', handleRouteStart);
    router.events.on('routeChangeComplete', handleRouteComplete);
    router.events.on('routeChangeError', handleRouteError);

    // Cleanup on unmount
    return () => {
      router.events.off('routeChangeStart', handleRouteStart);
      router.events.off('routeChangeComplete', handleRouteComplete);
      router.events.off('routeChangeError', handleRouteError);
    };
  }, [router]);

  return <></>;
};

export default ProductGridSkeletonTrigger;
